/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTileData} from '../api'

export const useMutationUpdateTileData = createReactQueryMutationHook('updateTileData', updateTileData)
